<script>
import FeatureBlock from '@/components/FeatureBlock.vue'
import {mediaQuery} from '@/mixins/mediaQuery'
export default {
  name: 'HowTherapyUnfolds',
  components: {
    FeatureBlock
  },
  data () {
    return {
      vidPlaying: false,
    }
  },
  mixins: [mediaQuery],
  methods: {
    playDemoVideo () {
      this.vidPlaying = true
      this.$refs['demo-video'].play()
    }
  }
}
</script>
<template>
  <section
    class="better-foundation"
    :class="mediaClass"
  >
    <header class="better-foundation-header">
      <h2 class="h2-promo text-outline-dark has-text-white">
        Built for How Therapy Unfolds
      </h2>
    </header>
    <div class="bf-grid">
      <video
          title="Video demo of OVB with audio"
          ref="demo-video"
          poster="/video/demo_poster@0.5x.webp"
          class="video-player"
          src="/video/demo.webm"
          controls
      />
      <article class="col-right">
        <article class="feature-grid">
          <feature-block class="dark-blue-block">
            <template #title>
              Structured Skill Progression
            </template>
            <template #content>
              Skills develop from early acquisition to real-world use
            </template>
          </feature-block>
          <feature-block class="dark-blue-block">
            <template #title>
              Clinician-Guided Adaptation
            </template>
            <template #content>
              Therapy demand adjusts as patients progress
            </template>
          </feature-block>
          <feature-block class="dark-blue-block">
            <template #title>
              Sustained Compliance
            </template>
            <template #content>
              Intentional variety keeps therapy practice sustainable over time
            </template>
          </feature-block>
        </article>
        <blockquote class="component-box mt-4 font-semibold quote-box">
          <p>
            "OVB is a game changer; they have built a better mousetrap. Compliance is way up because my patients are engaged. They weren't having fun before and now they are.
          </p>
          <p class="my-2">
            I love OVB in-office and know my patients are having fun with their VT homework."
          </p>
          <p class="" style="text-align: right;">&mdash;Dr. Ryan Capouch, OD FCOVD</p>
        </blockquote>
      </article>
    </div>
  </section>
</template>
<style scoped lang="scss">
.better-foundation {
  padding: 4rem 0;
  @include tablet {
    padding: 10rem 0 10rem 0;
  }
  @include desktop {
    padding: 0 0 20rem 0;
  }
  &-header {
    text-align: center;
  }
  &.is-mobile {
    padding-bottom: 0;
  }
}
.bf-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;
  margin-top: 1rem;
  @include desktop {
    margin-top: 2rem;
    grid-template-columns: 1fr 1fr;
  }
 }
.col-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.feature {
  &-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1rem;
    @include tablet {
      grid-template-columns: 1fr 1fr 1fr;
    }
    &-item {}
  }
  &-box {
    &-title {
      font-size: $size-5;
      font-family: $family-semibold;
      line-height: $size-5;
      margin-bottom: 0.5rem;
    }
    &-content {
      font-size: $size-6;
      line-height: 1.15;
    }
  }
}

.video-player {
  border-radius: 0.375rem;
  display: block;
  margin: 0;
  padding: 0
}
.quote-box {
  color: $text;
  background-color: #DED5C3;
}
.responsive-rows {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
  @include tablet {
    display: grid;
    grid-template-columns: repeat( auto-fill, minmax(30rem, 1fr));
    grid-column-gap: 2rem;
    grid-row-gap: 1rem;
  }
  @include desktop {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 2rem;
    grid-row-gap: 1rem;
  }
  @include widescreen {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 2rem;
    grid-row-gap: 1rem;
  }
}

</style>
